/*
 * Copyright (c) 2026
 */
import { type ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

type HolidayPortalProps = {
  children: ReactNode
}

export function HolidayPortal({ children }: HolidayPortalProps) {
  const [container, setContainer] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setContainer(document.body)
  }, [])

  if (!container) {
    return null
  }

  return createPortal(children, container)
}
